import { ComponentRoute } from '@/classes'

const CreditorListRoutes = {
  CreditorListListView: new ComponentRoute('/creditorlist', 'CreditorListListView')
}

export default CreditorListRoutes